import { gql } from '@apollo/client'

/*const DRAFT_OUTBOUND_DELIVERIES_BY_COMMAND_ID = gql`
  query draftOutboundDeliveries(
    $idSaleOrder: String
    $first: Int
    $after: Cursor
    $before: Cursor
    $last: Int
  ) {
    draftOutboundDeliveries(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: { idSaleOrder: { equalTo: $idSaleOrder } }
    ) {
      edges {
        node {
          code
          constructionSiteAddress
          constructionSiteCity
          constructionSiteCode
          constructionSitePostcode
          createdAt
          destinationSite
          externalReference
          forwardingAgent
          id
          idClient
          idConstructionSite
          idFreightForwarder
          idInternalTransfert
          idSaleOrder
          idSite
          idTruck
          internalIdSalesOrder
          nodeId
          saleOrderClientName
          status
          truckLicencePlate
          updatedAt
          draftOutboundDeliveryItemsByIdDraftOutboundDelivery {
            nodes {
              id
              idDraftOutboundDelivery
              idMaterial
              nodeId
              quantity
              updatedAt
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`*/
const DRAFT_OUTBOUND_DELIVERIES_BY_COMMAND_ID = gql`
  query draftOutboundDeliveries(
    $idSaleOrder: String
    $first: Int
    $after: Cursor
    $before: Cursor
    $last: Int
  ) {
    draftOutboundDeliveries(
      first: $first
      after: $after
      before: $before
      last: $last
      filter: { idSaleOrder: { equalTo: $idSaleOrder } }
    ) {
      edges {
      node {
        id
        saleOrderClientName
        truckLicencePlate
        createdAt
        draftOutboundDeliveryItemsByIdDraftOutboundDelivery {
          edges {
            node {
              materialByIdMaterial {
                description
                internalId
                id
                measureUnitByBaseMeasureUnitCode {
                  abbr
                }
              }
              quantity
            }
          }
        }
      }
    }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`

export default {
  DRAFT_OUTBOUND_DELIVERIES_BY_COMMAND_ID,
}
